/* eslint-disable no-useless-computed-key */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { Box, Tab } from "@mui/material";
import { Col, Image, Row } from "antd";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import { useParams, NavLink } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard.js";
import crudActions from "../../../../CRUD/redux/actions";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import Feature from './Feature';
import Component from './Component';
import { toast } from 'react-toastify';
import actions from "../../redux/actions";
import { checkCRUDViewPermission, checkCRUDPermission } from '../../../../../helpers/utilities';

const ModuleView = (props) => {
    const { readDetails, createDetails, createError, editDetails, editError, getList, getData } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleId } = useParams();
    const { history } = props;
    const { componentDetails, featureComponentDetails } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const [value, setValue] = useState("Feature");
    const [visible, setVisible] = useState(false);
    const [componentVisible, setComponentVisible] = useState(false);
   // const [showDetails, setShowDetails] = useState(true);
    const [addMore, setAddMore] = useState(false);
    const [errorComponent, setErrorComponent] = useState(false);
    const [errorFeature, setErrorFeature] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    const childRef = useRef(null);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [commonError, setCommonError] = useState("");
    //const prevReadDetails = usePrevious(readDetails);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();

    // useEffect(() => {
    //     if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
    //         setShowDetails(false);
    //     }
    // }, [readDetails]);

    const loadTasks = useCallback(() => {
        if (componentDetails.length === 0) {
            dispatch({
                type: actions.COMPONENT_DETAILS_START, filter: {
                    order: 'id  desc'
                }
            });
        }
        dispatch({ type: crudActions.READ_DETAILS_START, id: moduleId, url: "modules" });
        return () => {
            dispatch({ type: crudActions.CLEAR_CRUD_DETAILS_START });
        }
    });

    const loadTasksComponent = useCallback(() => {
        dispatch({
            type: actions.FEATURE_COMPONENT_DETAILS_START, filter: {
                order: 'id desc'
            }
        });
    });

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const loadTasksOthers = useCallback((skip = 0, sorttBy = sortBy, sorttOrder = sortOrder) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        loadTasksComponent();
        setSkip(skip);
        let filter = { ["and"]: [{ moduleId: parseInt(moduleId) }] };
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'features',
            skip: skip,
            filter: {
                where: filter,
                order: sorttBy + ' ' + sorttOrder,
                limit: limit,
                skip: skip,
            }
        });
    });

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('Module List', 'view', history, 'Younote Admin')) {
            loadTasks();
            loadTasksOthers();
        }
    }, [roleManagement]);

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(createDetails);
            setVisible(false);
            loadTasksOthers();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    handleOpen();
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            setCommonError(createError.error.message)
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
            loadTasksOthers();
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            if (text.includes("ER_DUP_ENTRY")) {
                if (componentVisible) {
                    setErrorComponent("Component already exits");
                } else {
                    setErrorFeature("Feature already exits");
                }
            }
        }
    }, [editDetails, editError]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOpen = () => {
        setVisible(true);
        setCommonError(false);
        childRef.current.handleOpen();
    }

    const onEdit = (data) => {
        setVisible(data);
    }

    const handleFeatureAddMore = () => {
        setAddMore(true);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        loadTasksOthers(s);
    }
    const changeComponentVisible = (data) => {
        setComponentVisible(data);
        setErrorComponent(false);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        loadTasksOthers(0, sortBy, sortOrder);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                cls={'newImg'}
                img={SettingsImg}
                title={'Younote Admin'}
                links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Module List', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Module'}
                    customClass={clsx(classes.customerSettlement, classes.customerSettlementModule)}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col span={3}><span className={classes.bold}>{readDetails.module}</span></Col>
                                <Col span={21} className={clsx(classes.textAlignRight, classes.removeUnderline)}>
                                    {
                                        value === 'Feature' && <>
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Module List', 'edit', 'Younote Admin') &&
                                                <NavLink to="#" onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline, classes.cursor)}>
                                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Feature</span>
                                                </NavLink>
                                            }
                                        </>
                                    }
                                </Col>
                            </Row>
                            <TabContext value={value}>
                                <Box className={classes.tabDesign}>
                                    <TabList onChange={handleChange} >
                                        <Tab className={classes.Bordertab_1} label="Feature" value={"Feature"} />
                                        <Tab className={classes.Bordertab_2} label="Component" value={"Component"} />
                                    </TabList>
                                </Box>
                                <TabPanel value={"Feature"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow, classes.customRowRoles)}>
                                                <Feature
                                                    ref={childRef}
                                                    loadMore={loadMore}
                                                    loadMoreContent={loadMoreContent}
                                                    loadMoreTask={() => loadMoreTask()}
                                                    loadTasks={() => loadTasksOthers()}
                                                    onParentEdit={(data) => onEdit(data)}
                                                    errorFeature={errorFeature}
                                                    moduleName={readDetails?.module}
                                                    moduleId={moduleId}
                                                    featureVisible={visible}
                                                    sortOrder={sortOrder}
                                                    sortBy={sortBy}
                                                    onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                                                    details={getList}
                                                    roleManagement={roleManagement}
                                                    handleFeatureAddMore={() => handleFeatureAddMore()}
                                                    commonError={commonError}
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                                <TabPanel value={"Component"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow)}>
                                                <Component
                                                    loadMore={loadMore}
                                                    loadMoreContent={loadMoreContent}
                                                    loadMoreTask={() => loadMoreTask()}
                                                    loadTasksOthers={() => loadTasksOthers()}
                                                    details={getList}
                                                    componentType={componentDetails}
                                                    checkErrorComponent={errorComponent}
                                                    component={featureComponentDetails}
                                                    loadTasks={() => loadTasksComponent()}
                                                    roleManagement={roleManagement}
                                                    changeComponentVisible={(data) => changeComponentVisible(data)}
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                            </TabContext>
                        </>
                    }
                />

            </div>
        </React.Fragment>
    )

}

export default ModuleView;


